export default __webpack_public_path__ + "static/media/poignees.786b184c.png";